import { webKnots } from '../../../common/back/lace/webKnots'
import { lacePartsOfWeb1, lacePartsOfWeb2, upRightDownLeft } from './parts/laceParts'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfWeb, verticalPartOfWebWithLace } from './parts/verticalParts'

export const crossWebWithHalfNetLace = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWeb(ctx, web2Color, laceColor, stitchColor)
  // laceここから
  halfLace(ctx, laceColor)
  webKnots(ctx, laceColor, -50, 50) // 捕球面上のウェブ結び目
  webKnots(ctx, laceColor, -120, 120) // 捕球面上のウェブ結び目
}

export const crossWebWithHalfNetLaceWithLace = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  web2Color: string,
  laceColor: string,
  stitchColor: string
): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  verticalPartOfWebWithLace(ctx, web2Color, laceColor, stitchColor)
  // laceここから
  halfLace(ctx, laceColor)
  webKnots(ctx, laceColor, -90, 90) // 捕球面上のウェブ結び目
  webKnots(ctx, laceColor, -120, 120) // 捕球面上のウェブ結び目
}

const halfLace = (ctx: CanvasRenderingContext2D, laceColor: string): void => {
  // 左
  lacePartsOfWeb1(ctx, laceColor, 80, 155, 1, 0.8) //
  lacePartsOfWeb1(ctx, laceColor, 65, 175, 1, 0.8) //
  lacePartsOfWeb1(ctx, laceColor, 49, 194, 1, 0.8) //
  upRightDownLeft(ctx, laceColor, -17, 20)

  // // 右
  lacePartsOfWeb2(ctx, laceColor, 130, 25, 10, 0.8)
  lacePartsOfWeb2(ctx, laceColor, 118, 45, 10, 0.8)
  lacePartsOfWeb2(ctx, laceColor, 105, 65, 10, 0.8)
}
